import type { PurchaseLineResultDto } from '@siliconx/shared';

/**
 * SIL-2534: the reseller's inline margin figures for one workbench line,
 * mapped straight off the existing `purchase_engine.margin.v1` result as the
 * compute endpoint returns it. No pricing math here: every number is a field
 * the engine already computed.
 *
 * A suppressed current price means the engine could not price the line, so
 * every figure is null (rendered as a dash) rather than a number built on a
 * suppressed input.
 */
export interface InlineMargin {
  breakEvenBidUsd: number | null;
  bidAtTargetMarginUsd: number | null;
  /** Month offset of the best sell month by absolute margin dollars; null when unpriced. */
  bestMonth: number | null;
  confidenceGrade: PurchaseLineResultDto['confidenceGrade'];
}

type InlineMarginSource = Pick<
  PurchaseLineResultDto,
  'currentPriceSuppressed' | 'bestMonth' | 'breakEvenBidUsd' | 'bidAtTargetMarginUsd' | 'confidenceGrade'
>;

export function toInlineMargin(result: InlineMarginSource | undefined | null): InlineMargin {
  if (!result || result.currentPriceSuppressed) {
    return { breakEvenBidUsd: null, bidAtTargetMarginUsd: null, bestMonth: null, confidenceGrade: null };
  }
  return {
    breakEvenBidUsd: result.breakEvenBidUsd,
    bidAtTargetMarginUsd: result.bidAtTargetMarginUsd,
    bestMonth: result.bestMonth,
    confidenceGrade: result.confidenceGrade,
  };
}
